import { render, staticRenderFns } from "./containerBase.vue?vue&type=template&id=264eb78f&scoped=true&"
import script from "./containerBase.vue?vue&type=script&lang=ts&"
export * from "./containerBase.vue?vue&type=script&lang=ts&"
import style0 from "./containerBase.vue?vue&type=style&index=0&id=264eb78f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264eb78f",
  null
  
)

export default component.exports